import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    CartesianGrid,
    ResponsiveContainer,
    Label,
} from 'recharts';

const HistoryLineChart = ({ chartData, authors, yAxisLabel }) => {
    const [visibleAuthors, setVisibleAuthors] = useState([]);

    useEffect(() => {
        setVisibleAuthors(
            Object.fromEntries(authors.map(author => [author, true]))
        )
    }, [authors])

    const handleLegendClick = (event) => {
        const { value } = event;
        setVisibleAuthors(prev => ({
            ...prev,
            [value]: !prev[value],//toggle visibility for clicked date
        }));
    };

    return (
        <div style={{ overflowX: 'auto' }}>
            <div style={{ width: `${chartData.length * 50}px`, minWidth: '100%' }}>
                <ResponsiveContainer width="100%" height={500}>
                    <LineChart
                        data={chartData}
                        margin={{ top: 20, right: 30, left: 20, bottom: 100 }} // increase bottom margin>
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                            dataKey="date"
                            type="category"
                            tick={{ angle: 90, dx: 10, dy: 50 }}
                            interval={0}
                        >
                            <Label value={"Dates"} position={'insideBottom'} offset={-1} fontWeight= 'bold' />
                        </XAxis>
                        <YAxis>
                            <Label
                                style={{
                                    textAnchor: "middle",
                                    fontSize: "100%",
                                    fill: "black",
                                }}
                                angle={270}
                                position={'centerBottom'}
                                value={yAxisLabel}
                            />
                        </YAxis>
                        <Tooltip />
                        <Legend
                            onClick={handleLegendClick}
                            payload={authors.map((author, index) => ({
                                value: author,
                                type: "line",
                                color: `hsl(${index * 30},70%,50%)`,
                                inactive: !visibleAuthors[author],//Mark inactive dates
                            }))}
                            verticalAlign='top'
                            height={36}
                        />
                        {authors.map((author, index) => (
                            visibleAuthors[author] ? <Line
                                key={author}
                                type="monotone"
                                dataKey={author}
                                stroke={`hsl(${index * 30}, 70%, 50%)`}
                                activeDot={{ r: 8 }}
                            /> : null
                        ))}
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

// PropTypes validation
HistoryLineChart.propTypes = {
    chartData: PropTypes.array.isRequired,
    authors: PropTypes.array.isRequired,
    yAxisLabel: PropTypes.string.isRequired,
};

export default HistoryLineChart;